/**
 * @param {{ first_name?: string | null; last_name?: string | null } | null | undefined} profile
 * @returns {string | null} trimmed "First Last", or null if both empty
 */
export function getDisplayName(profile) {
  if (!profile) return null
  const first = typeof profile.first_name === 'string' ? profile.first_name.trim() : ''
  const last = typeof profile.last_name === 'string' ? profile.last_name.trim() : ''
  if (!first && !last) return null
  return [first, last].filter(Boolean).join(' ')
}
